import { useMemo } from 'react'
import { isBefore } from 'date-fns'
import isAfter from 'date-fns/isAfter'
import { parseToDate } from 'lib/helper'
import { StoreCalendarType } from 'types/storeCalendar'

const useCalendarsWithinRange = (
  storeCalendars: StoreCalendarType[],
  status: 'close' | 'open',
  start: Date,
  end: Date
) => {
  return useMemo(() => {
    return storeCalendars.filter((storeCalendar) => {
      return (
        storeCalendar.status === status &&
        isAfter(parseToDate(storeCalendar.date), start) &&
        isBefore(parseToDate(storeCalendar.date), end)
      )
    })
  }, [storeCalendars, status, start, end])
}

export default useCalendarsWithinRange
